import gql from 'graphql-tag';

export const schema = gql`
input brandInput {
  name: String
  _id: String
  subCategoryId: [subCategoryInput]
  isChecked: Boolean
}

input demoFilterInput {
  ethnicity: [ethnicityInput],
  gender: [ethnicityInput],
  country: [countryCityInput],
  audienceAge: [ethnicityInput],
  followers: socialMediaCountInput,
  ageRange: [ageRangeInput]
}

input countryCityInput {
  label: String!
  value: String
}

input subCategoryInput {
  name: String
  _id: String
}

input categoriesInput {
  value: String
  label: String
}

input audienceAgeOfferInput {
  age_13_17: Boolean,
  age_18_20: Boolean,
  age_21_24: Boolean,
  age_25_29: Boolean,
  age_30_34: Boolean,
  age_35_44: Boolean,
  age_45_64: Boolean,
  age_65_plus: Boolean
}`;

export const AUTH_USER_CLIENT = gql`
  query AuthUser {
    authUser @client {
      id
      authId
      displayName
      name
      surname
      email
      phone
    }
  }
`;

export const GET_NOTIFICATION_SETTING = gql`{
  notification @client {
    notification,
    emailNotification,
    }
  }
`;

export const GET_UNSEEN_MESSAGES = gql`{
  unseenMessages @client {
     offerId
     conversationId
     timestamp
     unseenMessageCount
     unseenMessage
     receiverId,
     senderId,
    }
  }
`;

export const GET_ACTIVE_ARTIST = gql`{
  activeArtist @client {
    _id
    artistImage
    name
    isDefault
    email
    }
  }
`;

export const GET_USERS_LIST_QUERY = gql`
  query getLearners($limit: Int, $page: Int, $searchKey: String, $isPagination: Boolean,
    $sort: String, $sortBy: Int,$userId: String, $status: String) {
    getLearners(limit: $limit, page: $page, searchKey: $searchKey, isPagination: $isPagination,
      sort:$sort, sortBy: $sortBy, userId: $userId, status: $status) {
      message,
      count,
      data {
        email,
        firstName,
        lastName,
        profileImage,
        isActive,
        _id,
        isLicenced,
        isVerified,
      },
      totalLicenceAssign,
      totalLicence,
    }
}`;

export const GET_PAYMENT_LOGIN_LINK_QUERY = gql`
  query getPaymentLoginLink{
    getPaymentLoginLink {
      message,
      data {
        url
      }
    }
}`;

export const GET_ADMIN_APP_FEEDBACK_LIST_QUERY = gql`
  query feedbackList($page: Int, $limit: Int, $key: String, $sort: String, $sortBy: Int) {
    feedbackList(page: $page, limit: $limit, key: $key, sort: $sort, sortBy: $sortBy) {
        message,
        data {
          firstName,
          lastName,
          email,
          phoneNumber,
          feedback{
            message,
            isReply,
          },
          createdAt,
          _id,
        },
        count,
    }
}`;

export const GET_USER_DATA_QUERY = gql`
  query getUser($userId: String) {
    getUser(userId: $userId) {
      data {
        _id,
        email,
        name,
        totalRevenue,
        totalOffer,
        managerFirstName,
        managerLastName,
        note,
        shippingAddress,
        country {
          label,
          value
        },
        city {
          label,
          value
        },
        state {
          label,
          value
        }
        contactNumber,
        primaryContactName,
        genre,
        bio,
        profileImage,
        artistImage,
        managerImage,
        companyName,
        socialMedia {
          instagram,
          facebook,
          twitter,
          website,
          spotify,
          youtube,
        }
        managerId {
          managerFirstName,
          managerLastName,
          email,
          managerImage,
          _id,
        }
        category{
        _id
        name
        subCategory{
          _id
          name
        }
      }
      notification,
      emailNotification,
      isQuestionnaireSkipped,
      }
    }
  }`;

export const VALIDATE_RESET_PASSWORD_TOKEN = gql`
  query verifyToken($token: String!){
    verifyToken(token: $token){
      message
      data {
        email
      }
    }
}`;

export const GET_ALL_USER_QUERY = gql`
  query getAllUser($page: Int, $limit: Int, $sort: String, $sortBy: Int, $role: String, $searchKey: String,
    $statusFilter: [String], $brandFilter: [brandInput], $demoFilter: demoFilterInput ) {
    getAllUser(page: $page, limit: $limit, role: $role, sort: $sort, sortBy: $sortBy, searchKey: $searchKey
      statusFilter: $statusFilter, brandFilter: $brandFilter, demoFilter: $demoFilter ) {
      message,
      data {
        _id,
        email,
        name,
        country {
          label,
          value
        },
        city {
          label,
          value
        },
        state {
          label,
          value
        },
        companyName,
        contactNumber,
        isActive,
        artistImage,
        managerImage,
        managerFirstName,
        managerLastName,
        createdAt,
        isActive,
        status,
        note,
        isDelete,
        totalRevenue,
        totalOffer,
        socialMedia {
          instagram,
          facebook,
          twitter,
          website,
          spotify,
          youtube,
        },
        managerData {
          email,
          managerFirstName,
          managerLastName,
        },
        rejectReason {
          preDefined,
          custom,
        },
        artistData{
          name,
          country {
            label,
            value
          },
          city {
            label,
            value
          },
          state {
            label,
            value
          },
          socialMedia {
            instagram,
            facebook,
            twitter,
            website,
            spotify,
            youtube,
          }
        }
        totalArtist,
        bio,
        genre,
        category{
          name
        },
        isGraphExists,
      },
      count,
      requestCount,
      paginationCount,
    }
}`;

export const GET_ALL_ARTIST_QUERY = gql`
query getAllArtist{
  getAllArtist{
    data {
      artistImage
      name
      isDefault
      _id
      email
    }
  }
}`;

export const GET_CATEGORY_ADMIN_QUERY = gql`
query getCategory{
  getCategory{
    data {
      name
      _id
      subCategoryId {
        name
        _id
      }
    }
  }
}`;

export const GET_RECOMENDED_ARTIST_QUERY = gql`
query recomendedUser($categories: [categoriesInput], $offerId: String, $country: [countryCityInput], $gender: [String], $audienceAge: audienceAgeOfferInput) {
  recomendedUser(categories: $categories, offerId: $offerId, country: $country, gender: $gender, audienceAge: $audienceAge) {
    data {
      _id,
      name
      email
      artistImage
      isRecomended
      isRequested,
      isAlreadyRequested,
      managerId{
        email
      },
      basePrice,
    }
  }
}`;

export const GET_RECENT_ACTIVITIES = gql`
query recentActivities($artistId: ID) {
  recentActivities(artistId:$artistId) {
    message,
    data {
      type,
      email,
      offerId {
        title,
        clientLogo,
        _id,
      }
      createdAt,
      _id,
      rejectReason{
        custom,
        preDefined
      }
    }
  }
}`;

export const GET_CHAT_ROOM = gql`
query getChatRoom($participants: [ID], $offerId: ID!, $chatInitiator: ID) {
  getChatRoom(participants: $participants, offerId: $offerId, chatInitiator: $chatInitiator) {
    _id
    }
}`;

export const GET_ARTIST_TIMELINE_INFO = gql`
query artistTimeLine($offerId: ID!, $artistId: ID!) {
  artistTimeLine(offerId: $offerId, artistId: $artistId) {
    message,
    data{
      createContract,
      status,
      basePrice,
      userId{
        artistImage
        name
        _id
        email
        country {
          label,
          value
        },
        city {
          label,
          value
        },
        state {
          label,
          value
        }
      }
      participantsTimeLine{
        createdAt,
        status
      }
      timeline{
        startDate
        endDate
        betaPostInfo
        media{
          _id
          url
          thumbnail
          mediaType
        }
        shareType{
          instagram
          facebook
          twitter
          spotify
          youtube
        }
        sharedPost{
          instagram
          instagramUrl
          facebook
          facebookUrl
          twitter
          twitterUrl
          spotify
          spotifyUrl
          youtube
          youtubeUrl
        }
        campaignTitle
        description
        hashTag
        status
        _id
        timeLine{
          createdAt,
          status,
        },
      }
    }
  }
}`;

export const GET_ADMIN_ANALYTICS = gql`
query offerAnalytics($page: Int, $limit: Int){
  offerAnalytics(page: $page, limit: $limit){
    message
    data {
      startDate
      endDate
      betaPostInfo
      isNotification
      media{
        _id
        url
        thumbnail
        mediaType
      }
      shareType{
        instagram
        facebook
        twitter
        spotify
        youtube
      }
      sharedPost{
        instagram
        instagramUrl
        facebook
        facebookUrl
        twitter
        twitterUrl
        spotify
        spotifyUrl
      }
      campaignTitle
      description
      hashTag
      segmentId
      status
      _id
      rejectReason{
        preDefined
        custom
      }
      userId{
        name
        artistImage
        _id
      }
      offerId {
        title
        clientName
        _id
      }
      approvedDate
      isNotification
    }
    count
    hasNextData
  }
}`;

export const GET_DUE_BETA_POST = gql`
query dueBetaPost{
  dueBetaPost{
    message
    data {
      startDate
      endDate
      betaPostInfo
      media{
        _id
        url
        thumbnail
        mediaType
      }
      shareType{
        instagram
        facebook
        twitter
        spotify
      }
      sharedPost{
        instagram
        instagramUrl
        facebook
        facebookUrl
        twitter
        twitterUrl
        spotify
        spotifyUrl
      }
      campaignTitle
      description
      hashTag
      segmentId
      status
      _id
      rejectReason{
        preDefined
        custom
      }
      userId{
        name
        artistImage
        _id
      }
      offerId {
        title
        clientName
        _id
      }
      approvedDate
    }
  }
}`;

export const GET_ADMIN_INFO = gql`
query adminInfo{
  adminInfo{
    message
    data{
      _id
    }
    }
}`;

export const GET_CHAT_HISTORY = gql`
query getChatHistory{
  getChatHistory{
      _id
    }
}`;

export const GET_RECENT_UPDATE_OFFERS = gql`
query recentUpdatedOffer($participants: [ID], $offerId: ID!, $chatInitiator: ID) {
  getChatRoom(participants: $participants, offerId: $offerId, chatInitiator: $chatInitiator) {
    _id
    }
}`;

export const GET_ADMIN_NOTIFICATION = gql`
query adminNotification{
  adminNotification{
    artistRequest
    managerRequest
    offerNotification
    analyticsRequest
    betaPostRequest
    offerRequest
    duePost
    }
}`;

export const GET_GENRE = gql`
query getGenre{
  getGenre{
   data{
     _id
     name
   }
    }
}`;

export const GET_REVENUE = gql`
query getRevenue($artistId: ID) {
  getRevenue(artistId: $artistId) {
    data {
    totalRevenue
  }
    }
}`;

export const GET_ARTIST_NOTIFICATION = gql`
query artistNotification($artistId: String!) {
  artistNotification(artistId: $artistId) {
      publicHeaderNotification
      affiliateHeaderNotification
      privateHeaderNotification
      passedHeaderNotification
      myOfferHeaderNotification
      offerIds
    }
}`;

export const GET_USER_GIGS = gql`
  query gigsCount{
    gigsCount{
      publicCount
      privateCount
      myGigs
      affiliateCount
    }
  }
`;
